module.exports = __webpack_public_path__ + "static/media/vivere.08408e6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/vivere.png
// module id = 961
// module chunks = 0